﻿import angular from "angular";
import "../../../services/cart";
import "../../../services/countries";
import "../../../services/user";
import * as dawaAutocomplete from "dawa-autocomplete2";

angular.module("folkeuni").component("customerInfo", {
  templateUrl: "/shop-dist/templates/customer-info.html?c=" + window.cacheBurst,
  bindings: {
    cart: "<",
    state: "<",
    siteId: "<"
  },
  controller: function (
    Cart,
    Countries,
    User,
    $scope,
    $location,
    $element,
    $timeout
  ) {
    var $ctrl = this;
    $ctrl.showAddressFields = false;
    $ctrl.postalCodeMax = 4;
    $ctrl.suggestions = { customer: {}, company: {} };
    var defaultObj = { customer: {}, company: {} };

    $ctrl._postalCodePattern = new RegExp(
      "^[0-9]{" + $ctrl.postalCodeMax + "}$"
    );
    $ctrl.countryChange = function () {
      const selectedCountry = $ctrl.countries.find(
        (c) => c.code === $ctrl.cart.checkout.customer.country
      );
      if (selectedCountry && selectedCountry.code === "DK") {
        $ctrl.postalCodeMax = 4;
      } else {
        $ctrl.postalCodeMax = 6;
      }
      $ctrl._postalCodePattern = new RegExp(
        "^[0-9]{" + $ctrl.postalCodeMax + "}$"
      );
    };

    $ctrl.getPostalCodePattern = function () {
      return $ctrl._postalCodePattern;
    };

    $ctrl.countries = [];

    $ctrl.paymentTypes = [
      { value: "Invoice", label: "Faktura" },
      { value: "Card", label: "Med kort" },
    ];

    $ctrl.$onInit = function () {
      $ctrl.countries = Countries.getAll;
      $ctrl.cart.checkout = $ctrl.cart.checkout
        ? $ctrl.cart.checkout
        : defaultObj;

        $ctrl.cart.checkout.customer.fullStreetAddress = "";

      if (!$ctrl.cart.checkout.customer) {
        $ctrl.cart.checkout.customer = {};
      }

      if ($ctrl.cart.checkout.customer.streetName) {
        $ctrl.showAddressFields = true;
      }

      if (!$ctrl.cart.checkout.customer.country) {
        $ctrl.cart.checkout.customer.country = "DK";
      }
      // Sæt default paymentType hvis ikke sat
      if (
        $ctrl.cart.checkout.company &&
        !$ctrl.cart.checkout.company.paymentType &&
        $ctrl.paymentTypes &&
        $ctrl.paymentTypes.length > 0
      ) {
        $ctrl.cart.checkout.company.paymentType = $ctrl.paymentTypes[0].value;
      }

      User.getCurrent().then(
        function (userObj) {
          userObj.phoneNumber = Number(userObj.phoneNumber);

          let countryCode = userObj.country;
          if (countryCode && countryCode.indexOf(":") > 0) {
            countryCode = countryCode.split(":")[0];
          }

          const foundCountry = $ctrl.countries.find(
            (c) => c.code === countryCode
          );

          userObj.country = foundCountry ? foundCountry.code : "DK";

          $ctrl.cart.checkout.customer = userObj;
          $ctrl.cart.checkout.customer.confirmEmail = userObj.email;
          $ctrl.cart.checkout.customer.isLoggedIn = true;
          $ctrl.showAddressFields = true;
        },
        function (error) { }
      );

      $ctrl.countryChange();
      $ctrl.cart.checkout.customer.createUser = false;

      $timeout(function () {
        var streetnameInput = $element[0].querySelector("#dawaAddress");
        if (streetnameInput) {
          dawaAutocomplete.dawaAutocomplete(streetnameInput, {
            select: function (selected) {
              $scope.$apply(function () {
                $ctrl.cart.checkout.customer.streetNumber = selected.data.husnr;
                $ctrl.cart.checkout.customer.streetName = selected.data.vejnavn;
                $ctrl.cart.checkout.customer.postalCode = Number(
                  selected.data.postnr
                );
                $ctrl.cart.checkout.customer.city = selected.data.postnrnavn;
                $ctrl.cart.checkout.customer.floorNumber = selected.data.etage;
                if (
                  selected.data.dør != null &&
                  !isNaN(Number(selected.data.dør))
                ) {
                  $ctrl.cart.checkout.customer.roomNumber =
                    selected.data.dør != undefined
                      ? selected.data.dør.toString()
                      : null;
                  $ctrl.cart.checkout.customer.side = null;
                } else {
                  $ctrl.cart.checkout.customer.side =
                    selected.data.dør != undefined && selected.data.dør != null
                      ? selected.data.dør.toString()
                      : null;
                  $ctrl.cart.checkout.customer.roomNumber = null;
                }

                Cart.customerInfoLocalStorageSet($ctrl.cart);
              });
            },
          });
        }
      }, 0);

      if (
        $scope.$parent &&
        $scope.$parent.$ctrl &&
        $scope.$parent.$ctrl.registerValidityChecker
      ) {
        $scope.$parent.$ctrl.registerValidityChecker($ctrl.isValid);
      }
    };

    $ctrl.isValid = function () {
      var form = $element.find('form[name="customerInfo"]')[0];
      if (!form) return false;
      return $scope.customerInfo && $scope.customerInfo.$valid;
    };

    var customerInfoChangedTimeout;
    $ctrl.customerInfoChanged = function () {
      if (customerInfoChangedTimeout) {
        $timeout.cancel(customerInfoChangedTimeout);
      }
      customerInfoChangedTimeout = $timeout(function () {
        Cart.customerInfoLocalStorageSet($ctrl.cart);
      }, 500);
    };

    $ctrl.compareEmails = function () {
      var input = $scope.customerInfo.confirmEmail;

      if (
        $scope.customerInfo.confirmEmail &&
        $scope.customerInfo.confirmEmail != ""
      ) {
        if (
          $ctrl.cart.checkout.customer.confirmEmail !=
          $ctrl.cart.checkout.customer.email
        ) {
          input.$setValidity("match", false);
          if (input && input.$setTouched) input.$setTouched();
        } else {
          input.$setValidity("match", true);
          if (input && input.$setTouched) input.$setTouched();
        }
      }
    };

    $ctrl.comparePasswords = function () {
      var input = $scope.customerInfo.confirmPassword;

      if (
        $scope.customerInfo.confirmPassword &&
        $scope.customerInfo.confirmPassword != ""
      ) {
        if (
          $ctrl.cart.checkout.customer.confirmPassword !=
          $ctrl.cart.checkout.customer.password
        ) {
          input.$setValidity("match", false);
          if (input && input.$setTouched) input.$setTouched();
        } else {
          input.$setValidity("match", true);
          if (input && input.$setTouched) input.$setTouched();
        }
      }
    };

    // Custom EAN validering (Som på backend)
    $ctrl.eanInvalid = false;
    $ctrl.validateEAN = function () {
      const ean = $ctrl.cart.checkout.company.ean;
      if (!ean || !/^57[0-9]{11}$/.test(ean)) {
        $ctrl.eanInvalid = false;
        return;
      }
      let sum = 0;
      for (let i = 11; i >= 0; i--) {
        const digit = parseInt(ean[i], 10);
        if ((i & 1) === 0) sum += digit;
        else sum += digit * 3;
      }
      const check = (10 - (sum % 10)) % 10;
      const last = parseInt(ean[12], 10);
      $ctrl.eanInvalid = check !== last;
    };

    $ctrl.patterns = {
      firstName: /^[\p{L} .'-]{1,25}$/u,
      middleName: /^[\p{L} .'-]{1,25}$/u,
      lastName: /^[\p{L} .'-]{1,25}$/u,
      streetName: /^[\p{L}0-9 .'-]{2,50}$/u,
      phoneNumber: /^\+?[0-9]{8,30}$/,
      streetNumber: /^[0-9\w .]{1,10}$/,
      floorNumber: /^[\w.]{1,3}$/,
      roomNumber: /^[\p{L}0-9 .'-]{1,10}$/u,
      side: /^[\w .]{1,4}$/,
      city: /^[\p{L} .'-]{2,30}$/u,
      company: /^[\p{L}0-9 .'\-/]{2,50}$/u,
      cvr: /^[0-9]{8}$/,
      ean: /^57[0-9]{11}$/,
      reference: /^[\p{L}0-9 .'-]{2,20}$/u,
      requisition: /^[\p{L}0-9 .'-]{2,30}$/u,
      account: /^[\p{L}0-9 .'-]{2,30}$/u,
      email: /^[\p{L}0-9.+_-]+@([\p{L}0-9-]+\.)+[a-z]{2,}$/u,
    };

    $scope.$on("checkout:showAllErrors", function () {
      if ($scope.customerInfo) {
        angular.forEach($scope.customerInfo, function (field, key) {
          if (field && field.$setTouched) field.$setTouched();
        });

        $ctrl.compareEmails();
      }
    });

    var emailExistsTimeout;
    $ctrl.asyncEmailCheckInProgress = false;
    $ctrl.emailExistsError = false;
    $ctrl.checkEmailExists = function () {
      if (!$ctrl.cart.checkout.customer.createUser) {
        $ctrl.emailExistsError = false;
        if ($scope.customerInfo && $scope.customerInfo.email) {
          $scope.customerInfo.email.$setValidity("emailexists", true);
        }
        return;
      }
      var email = $ctrl.cart.checkout.customer.email;
      if (!email || !$ctrl.patterns.email.test(email)) {
        $ctrl.emailExistsError = false;
        if ($scope.customerInfo && $scope.customerInfo.email) {
          $scope.customerInfo.email.$setValidity("emailexists", true);
        }
        return;
      }
      if (emailExistsTimeout) $timeout.cancel(emailExistsTimeout);
      $ctrl.asyncEmailCheckInProgress = true;
      emailExistsTimeout = $timeout(function () {
        User.exists($ctrl.siteId, email).then(
          function () {
            $ctrl.asyncEmailCheckInProgress = false;

            $ctrl.emailExistsError = false;
            if ($scope.customerInfo && $scope.customerInfo.email) {
              $scope.customerInfo.email.$setValidity("emailexists", true);
            }
          },
          function (err) {
            $ctrl.asyncEmailCheckInProgress = false;
            // Hvis API'et returnerer 409, så eksisterer brugeren
            if (err && err.status === 409) {
              $ctrl.emailExistsError = true;
              if ($scope.customerInfo && $scope.customerInfo.email) {
                $scope.customerInfo.email.$setValidity("emailexists", false);
                $scope.customerInfo.email.$setTouched();
              }
            } else {
              // Ved andre fejl antag at email ikke findes
              $ctrl.emailExistsError = false;
              if ($scope.customerInfo && $scope.customerInfo.email) {
                $scope.customerInfo.email.$setValidity("emailexists", true);
              }
            }
          }
        );
      }, 400);
    };

    $scope.$watchGroup(
      [
        function () {
          return $ctrl.cart.checkout.customer.email;
        },
        function () {
          return $ctrl.cart.checkout.customer.createUser;
        },
      ],
      function () {
        $ctrl.checkEmailExists();
      }
    );
  },
});
